/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type Footer_viewer$ref = any;
export type FooterRefetchQueryVariables = {
    readonly userId: string;
    readonly hasUserId: boolean;
};
export type FooterRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": Footer_viewer$ref;
    } | null;
};
export type FooterRefetchQuery = {
    readonly response: FooterRefetchQueryResponse;
    readonly variables: FooterRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "FooterRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Footer_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "FooterRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": "isTradeExperienceEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "TRADE_EXPERIENCE"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"TRADE_EXPERIENCE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSellerApplicationEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "SELLER_APPLICATION"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"SELLER_APPLICATION\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isAboutUsPageEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "ABOUT_US_PAGE"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"ABOUT_US_PAGE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isCareersPageEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "CAREERS_PAGE"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"CAREERS_PAGE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isPressPageEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "PRESS_PAGE"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"PRESS_PAGE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isQuestionsPageEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "QUESTIONS_PAGE"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"QUESTIONS_PAGE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSiteMapsEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "HTML_SITE_MAPS"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"HTML_SITE_MAPS\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "disableFooterSubscribe",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "disableFooterSubscribe"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"disableFooterSubscribe\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "currencies",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "doNotShowPrivacyPolicyAlerts",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "doNotShowPrivacyPolicyAlerts"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"doNotShowPrivacyPolicyAlerts\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isDownloadAppEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "DOWNLOAD_APP"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"DOWNLOAD_APP\")"
                        },
                        (v1 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "userId",
                                            "variableName": "userId"
                                        }
                                    ],
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "serviceId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "currency",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "FooterRefetchQuery",
            "id": "ferrum/229.0.0-2019-08-16T16:11:05.237Z/FooterRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8558e4bfe559dbfef2fcb488643739a2';
export default node;
